import { useCallback, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { processError } from "../../../../common/utils/base_error";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { useUserAuthStore } from "../../../../stores/global/userAuth";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { useCachedDataLoader } from "../../../../common/hooks/use_cached_data_loader";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { useDropDownLoader } from "../../../../common/hooks/use_dropdown_loader";
import { RangedDate } from "../../../../common/utils/ranged_date_utils";

import CommonConstants from "../../../../common/constants";
import { FuncionarioTabela } from "../../../rh/domain/models/funcionario_tabela";
import { useFuncionariosTercerizacaoFilters } from "../hooks/Funcionarios_tercerizacao_lista/filters";
import { useFuncionariosTercerizacaoPagination } from "../hooks/Funcionarios_tercerizacao_lista/pagination";
import { FuncionarioTerc } from "../../../rh/domain/models/funcionario_terc";
import { FuncionarioTercLista } from "../../domain/models/funcionarios_tercerizado_lista";
import { AlterarInativoAtivoForm } from "../schemas/Funcionario_Terc/alterar_inativo_ativo";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

// useFuncionariosTerceirizado ListaViewModel

type LoadFuncionarioTercState = {
  IdFuncionarioTerc?:number,
  NomePesquisa?: string;
  FornecedorPesquisa?: number;
  ContratoPesquisa?: number;
  CargoPesquisa?: number;
  centroDeCustoLista?: { id: number; title: string }[];
  centroDeCusto?: number[];
  StatusPesquisa?: number;
  AvaliacoesPesquisa?: number;
  DocumentosPesquisa?: number;
  page?: number;
  rowsPerPage?: number;
};

export const useFuncionariosTerceirizadoListaViewModel = () => {
  const {
    commons: {},
    reports:{ getReportListaFuncionariosTUseCase },
    terceirizacao: {
      getAllListagemFuncionariosTercUseCase,
      alterarInativoAtivoFuncionariosUseCase,
      deleteFuncionariosTercUseCase,
    },
  } = useDependencyInjection();

  const {
    loadCentroCustoDropDown,
  } = useDropDownLoader();
   const { d, av, s } = useParams();

  const debouncedRef = useCreateDebounceHandler(750);

  const menuRef = useRef<HTMLButtonElement>(null);

  const {  pushErrorNotification, pushWarnNotification } = usePageLoader();

  const [openMenu, setOpenMenu] = useState(false);

  const [openReportsFuncionarios, setOpenReportsFuncionarios] = useState(false);

  const [errorMessage, setErrorMessage] = useState<string>();
  const [funcionarios, setFuncionarios] = useState<FuncionarioTercLista[]>();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [selectedFuncionario, setSelectedFuncionario] = useState<FuncionarioTercLista>();


  const [openLegendaModal, setOpenLegendaModal] = useState(false);

  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>();
  const [alterarInativoAtivoModal, setAlterarInativoAtivoModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);


  const navigate = useNavigate();

  const filters = useFuncionariosTercerizacaoFilters();
  const pagination = useFuncionariosTercerizacaoPagination();

  //#region Relatorio
  const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  //Funções de carregamento

  const loadFuncionarioTerc = useCallback(async (funcState?: LoadFuncionarioTercState) => {
    try {
      setLoading(true);
      if(d !== undefined && d !== null) filters.DocumentosPesquisa = Number(d);
      if(av !== undefined && av !== null) filters.AvaliacoesPesquisa = Number(av);
      if(s !== undefined && s !== null) filters.StatusPesquisa = Number(s);

      const filteredIdFuncionarioTerc = funcState?.IdFuncionarioTerc ?? filters.IdFuncionarioTerc;
      const filteredcentroDeCusto = funcState?.centroDeCusto ?? filters.centroDeCusto;
      const filteredDocumentosPesquisa = funcState?.DocumentosPesquisa ?? filters.DocumentosPesquisa;
      const filteredAvaliacoesPesquisa = funcState?.AvaliacoesPesquisa ?? filters.AvaliacoesPesquisa;
      const filteredCargoPesquisa = funcState?.CargoPesquisa ?? filters.CargoPesquisa;
      const filteredStatusPesquisa = funcState?.StatusPesquisa ?? filters.StatusPesquisa;
      const filteredContratoPesquisa = funcState?.ContratoPesquisa ?? filters.ContratoPesquisa;
      const filteredFornecedorPesquisa = funcState?.FornecedorPesquisa ?? filters.FornecedorPesquisa;
      const filteredNomePesquisa = funcState?.NomePesquisa ?? filters.NomePesquisa;

      const page = funcState?.page ?? pagination.page;
      const rowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;

      await getAllListagemFuncionariosTercUseCase.getAllListagemFuncionarioTerc({AvaliacoesPesquisa: filteredAvaliacoesPesquisa, CargoPesquisa: filteredCargoPesquisa, centroDeCusto: filteredcentroDeCusto, ContratoPesquisa: filteredContratoPesquisa, DocumentosPesquisa: filteredDocumentosPesquisa, FornecedorPesquisa: filteredFornecedorPesquisa, NomePesquisa: filteredNomePesquisa, IdFuncionarioTerc: filteredIdFuncionarioTerc, StatusPesquisa: filteredStatusPesquisa},
        page,
        rowsPerPage,
      );

      setFuncionarios(getAllListagemFuncionariosTercUseCase.items);

      pagination.setRowsPerPage(getAllListagemFuncionariosTercUseCase.pageSize);
      pagination.setTotalItems(getAllListagemFuncionariosTercUseCase.totalItems);
      setLoading(false);
    } catch (e: unknown) {
      setLoading(false);
      throw new Error("Falha ao buscar Funcionario Tercerizado!");
    }
  }, [filters.IdFuncionarioTerc, filters.centroDeCusto, filters.DocumentosPesquisa, filters.AvaliacoesPesquisa, filters.CargoPesquisa, filters.StatusPesquisa, filters.ContratoPesquisa, filters.FornecedorPesquisa, filters.NomePesquisa, pagination, getAllListagemFuncionariosTercUseCase]);

  

  /**
   * useEffects
   */

  usePageStartBootstrap(async () => {
    try {
      setErrorMessage(undefined);
      const jobs = [];
      jobs.push(loadFuncionarioTerc());
      jobs.push(loadCentroCustoDropDown(list => useFuncionariosTercerizacaoFilters.setState({ centroDeCustoLista: list })));
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao carregar pagina!")[0]);
    }
  });

  /**
   * Eventos
   */

  const handleReloadPage = useCallback(async () => {
    try {
      setLoading(true);
      await loadFuncionarioTerc();
      await loadCentroCustoDropDown(list => useFuncionariosTercerizacaoFilters.setState({ centroDeCustoLista: list }));
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionario!"));
    } finally {
      setLoading(false);
    }
  }, [loadCentroCustoDropDown, loadFuncionarioTerc, pushErrorNotification]);


  const handleFuncionarioEdit = useCallback((id: number | undefined, openNewTab: boolean) => {
    if (funcionarios && id) {
      const funcionario = funcionarios.find((x) => x.IdFuncionarioTerc === id);
      if (funcionario) {
        if (openNewTab) {
          navigate(`/FuncionarioTercerizacao_cadastro/${id}`);
        }
      }
    }
  }, [funcionarios, navigate]);

  //#region Funções de deletar
  const handleDeleteModalOpenState = useCallback((IdFuncionarioTerc: number | null, openState: boolean) => {
    if (openState) {
      if (IdFuncionarioTerc && funcionarios) {
        setSelectedFuncionario(funcionarios.find(x => x.IdFuncionarioTerc === IdFuncionarioTerc));
      } else {
        setSelectedFuncionario(undefined);
      }
    }
    setDeleteModal(openState);
  }, [funcionarios]);

  const handleDeleteConfirma = useCallback(async () => {
    if (selectedFuncionario?.IdFuncionarioTerc) {
      try {
        setSaving(true);
        await deleteFuncionariosTercUseCase.deleteFuncionariosTerc(selectedFuncionario.IdFuncionarioTerc);
        await loadFuncionarioTerc();
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao excluir informações!'));
      } finally {
        setSaving(false);
        setDeleteModal(false);
      }
    }
  },[selectedFuncionario, deleteFuncionariosTercUseCase, loadFuncionarioTerc, pushErrorNotification]);
  
  //#endregion

  
  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
        setLoading(true);
        pagination.setPage(1);
        pagination.setRowsPerPage(rowsPerPage);
        await loadFuncionarioTerc({ page: 1, rowsPerPage });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadFuncionarioTerc, pagination, pushErrorNotification]);

  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);;
      await loadFuncionarioTerc({page: page + 1,});
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadFuncionarioTerc, pagination, pushErrorNotification]);


  const handleReportsFuncionariosOpenState = useCallback((openState: boolean) => {
    setOpenReportsFuncionarios(openState);
    setOpenMenu(false);
  }, []);


  const handleRowSelectionModelChange = useCallback((rows: GridRowSelectionModel) => {
    setRowSelectionModel(rows);
  }, [
  ]);

  const handleOpenInativoAtivoModal = useCallback((openState: boolean) => {
    if (openState) {
      if (!rowSelectionModel || rowSelectionModel.ids.size === 0) {
        pushWarnNotification("Atenção", "Selecione os funcionarios a serem alterados!");
        return;
      }
    }
    setAlterarInativoAtivoModal(openState);
  }, [
    rowSelectionModel,
    pushWarnNotification,
  ]);
  
  const handleAlterarInativoAtivoSubmit = useCallback(async (form: AlterarInativoAtivoForm) => {
      try {
        setSaving(true);
        if (rowSelectionModel) {
          const idFuncionarios: number[] = [];
          for (let row of rowSelectionModel.ids.values()) {
            if (typeof row === 'number') {
              idFuncionarios.push(row);
            } else if (typeof row === 'string') {
              try {
                idFuncionarios.push(Number(row));
              } catch (e) {
              }
            }
          }
  
          await alterarInativoAtivoFuncionariosUseCase.alterarInativoAtivoFuncionarios(
            form.Ativo,
            form.DataTermino ?? null,
            idFuncionarios ?? [],
          );
  
          await loadFuncionarioTerc();
        }
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao atualizar funcionarios!"));
      } finally {
        setSaving(false);
        setAlterarInativoAtivoModal(false);
        setRowSelectionModel({ type: 'include', ids: new Set() });
      }
    }, [rowSelectionModel, alterarInativoAtivoFuncionariosUseCase, loadFuncionarioTerc, pushErrorNotification]);

  //#region Filtros
  const handleClearFilters = useCallback(async () => {
    try {
        setLoading(true);
        filters.clearFilters();
        pagination.setPage(1);
        await loadFuncionarioTerc();
    } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao buscar funcionarios!'));
    } finally {
        setLoading(false);
    }
  }, [filters, loadFuncionarioTerc, pagination, pushErrorNotification]);
  
  const handleFornecedorChange = useDebouncedCallback(debouncedRef, async (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setFornecedorPesquisa(newValue);

    try {
      setLoading(true);
      useFuncionariosTercerizacaoPagination.getState().setPage(1);
      await loadFuncionarioTerc({ FornecedorPesquisa: newValue, page: 1 } as any);
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
    } finally {
      setLoading(false);
    }

    return () => {};
  }, [pushErrorNotification, loadFuncionarioTerc]);
  
  const handleContratoChange = useDebouncedCallback(debouncedRef, async (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setContratoPesquisa(newValue);

    try {
      setLoading(true);
      useFuncionariosTercerizacaoPagination.getState().setPage(1);
      await loadFuncionarioTerc({ ContratoPesquisa: newValue, page: 1 } as any);
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
    } finally {
      setLoading(false);
    }

    return () => {};
  }, [pushErrorNotification, loadFuncionarioTerc]);
  
  const handleCentroDeCustoChange = useDebouncedCallback(debouncedRef, (newValue: number[]) => {
    useFuncionariosTercerizacaoFilters.getState().setCentroDeCusto(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ centroDeCusto: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification, ]);
  
  
  const handleCargoChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setCargoPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ CargoPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification,]);
  
  const handleFornecedorPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setFornecedorPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ FornecedorPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification,]);

  const handleAvaliacaoPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setAvaliacoesPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ AvaliacoesPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification,]);
  
  const handleDocumetosPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setDocumentosPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ DocumentosPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification,]);

  const handleNomePesquisaChange = useDebouncedCallback(debouncedRef, (newValue: string) => {
    useFuncionariosTercerizacaoFilters.getState().setNomePesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ NomePesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification]);

  const handleStatusPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useFuncionariosTercerizacaoFilters.getState().setStatusPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useFuncionariosTercerizacaoPagination.getState().setPage(1);
        await loadFuncionarioTerc({ StatusPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar funcionarios!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadFuncionarioTerc, pushErrorNotification]);
  //#endregion

  const handleShowLegenda = useCallback((openState: boolean) => {
    setOpenLegendaModal(openState);
  }, []);

  //#region  relatorio
  const handleReportListaFuncionarios = useCallback(async () => {
      try {
        setLoading(true);
  
        await startReportViewerProcess({
          fetchCallback: async (requiredMimeType) =>
            await getReportListaFuncionariosTUseCase.getReportListaFuncionariosT(requiredMimeType),
        });
  
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao gerar relatorio de lista funcionarios!'))
      } finally {
        setLoading(false);
      }
    }, [getReportListaFuncionariosTUseCase, pushErrorNotification, startReportViewerProcess]);

    //#endregion

  return {
    menuRef,
    openMenu,
    openReportsFuncionarios,
    loading,
    saving,
    funcionarios: funcionarios ?? [],
    pagination,
    errorMessage,
    filters,
    selectedFuncionario,
    deleteModal,
    openLegendaModal,
    rowSelectionModel,
    alterarInativoAtivoModal,
    reportViewerState,
    handleReloadPage,
    handleFuncionarioEdit,
    handleRowsPerPageChange,
    handlePageChange,
    handleReportsFuncionariosOpenState,
    handleRowSelectionModelChange,
    handleOpenInativoAtivoModal,
    handleAlterarInativoAtivoSubmit,
    handleShowLegenda,
    handleClearFilters,
    handleFornecedorChange,
    handleContratoChange,
    handleCargoChange,
    handleFornecedorPesquisaChange,
    handleDocumetosPesquisaChange,
    handleCentroDeCustoChange,
    handleAvaliacaoPesquisaChange,
    handleNomePesquisaChange,
    handleStatusPesquisaChange,
    handleDeleteModalOpenState,
    handleDeleteConfirma,
    handleReportListaFuncionarios,
  };
}